"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPTIONS_SMT_UTAT = exports.OPTIONS_SMT_RTAT = exports.OPTIONS_SMT_HFRAC = exports.OPTIONS_SMT_THERAPY = exports.OPTIONS_SMT_MISSING = exports.OPTIONS_SMT_DEVICE = exports.OPTIONS_SMT_COND = exports.OPTIONS_SMT_FRACTURE = exports.OPTIONS_SMT_EYE = exports.OPTIONS_SMT_DRUGS = exports.OPTIONS_SMT_DEFORM = exports.OPTIONS_SMT_DEAF = exports.OPTIONS_SMT_ART = exports.OPTIONS_SMT_TATTOO = exports.OPTIONS_SMT_DISC = exports.OPTIONS_SMT_SCAR = exports.OPTIONS_SMT_OTHER = exports.OPTIONS_SMT_NM = exports.OPTIONS_SMT_MOLE = exports.OPTIONS_SMT_TYPE = void 0;
exports.OPTIONS_SMT_TYPE = [
    ['0', 'MOLE'],
    ['1', 'NEEDLE MARKS'],
    ['2', 'OTHER PHYSICAL CHARACTERISTICS'],
    ['3', 'SCAR'],
    ['4', 'SKIN DISCOLORATION AND BIRTHMARKS'],
    ['5', 'TATTOO'],
    ['6', 'ARTIFICIAL BODY PARTS OR AIDS'],
    ['7', 'DEAFNESS'],
    ['8', 'DEFORMITIES'],
    ['9', 'DRUGS OF ABUSE'],
    ['10', 'EYE DISORDERS'],
    ['11', 'FRACTURED BONES'],
    ['12', 'MEDICAL CONDITIONS AND DISEASES'],
    ['13', 'MEDICAL DEVICES AND BODY IMPLANTS'],
    ['14', 'MISSING BODY PARTS AND ORGANS'],
    ['15', 'THERAPEUTIC DRUGS'],
    ['16', 'HEALED FRACTURED BONES'],
    ['17', 'REMOVED TATTOOS'],
    ['18', 'ULTRAVIOLET TATTOOS']
];
exports.OPTIONS_SMT_MOLE = [
    ['MOLE ABDOM', 'ABDOMEN'],
    ['MOLE L ANK', 'ANKLE, LEFT'],
    ['MOLE ANKL', 'ANKLE, NONSPECIFIC'],
    ['MOLE R ANK', 'ANKLE, RIGHT'],
    ['MOLE L ARM', 'ARM, LEFT'],
    ['MOLE LFARM', 'ARM, LEFT, LOWER'],
    ['MOLE ULARM', 'ARM, LEFT, UPPER'],
    ['MOLE ARM', 'ARM, NONSPECIFIC'],
    ['MOLE F ARM', 'ARM, NONSPECIFIC, LOWER'],
    ['MOLE R ARM', 'ARM, RIGHT'],
    ['MOLE RFARM', 'ARM, RIGHT, LOWER'],
    ['MOLE URARM', 'ARM, RIGHT, UPPER'],
    ['MOLE BACK', 'BACK'],
    ['MOLE LBRST', 'BREAST, LEFT'],
    ['MOLE BRST', 'BREAST, NONSPECIFIC'],
    ['MOLE RBRST', 'BREAST, RIGHT'],
    ['MOLE L BUT', 'BUTTOCK, LEFT'],
    ['MOLE BUTTK', 'BUTTOCK, NONSPECIFIC'],
    ['MOLE R BUT', 'BUTTOCK, RIGHT'],
    ['MOLE LCALF', 'CALF, LEFT'],
    ['MOLE CALF', 'CALF, NONSPECIFIC'],
    ['MOLE RCALF', 'CALF, RIGHT'],
    ['MOLE L CHK', 'CHEEK, LEFT'],
    ['MOLE CHK', 'CHEEK, NONSPECIFIC'],
    ['MOLE R CHK', 'CHEEK, RIGHT'],
    ['MOLE CHEST', 'CHEST'],
    ['MOLE CHIN', 'CHIN'],
    ['MOLE L EAR', 'EAR, LEFT'],
    ['MOLE EAR', 'EAR, NONSPECIFIC'],
    ['MOLE R EAR', 'EAR, RIGHT'],
    ['MOLE L ELB', 'ELBOW, LEFT'],
    ['MOLE ELBOW', 'ELBOW, NONSPECIFIC'],
    ['MOLE R ELB', 'ELBOW, RIGHT'],
    ['MOLE EYE', 'EYE, NONSPECIFIC'],
    ['MOLE L EYE', 'EYEBROW, LEFT/LEFT EYE AREA'],
    ['MOLE R EYE', 'EYEBROW, RIGHT/RIGHT EYE AREA'],
    ['MOLE FACE', 'FACE'],
    ['MOLE L FGR', 'FINGER(S), LEFT HAND'],
    ['MOLE R FGR', 'FINGER(S), RIGHT HAND'],
    ['MOLE FGR', 'FINGER, NONSPECIFIC'],
    ['MOLE L FT', 'FOOT, LEFT'],
    ['MOLE FOOT', 'FOOT, NONSPECIFIC'],
    ['MOLE R FT', 'FOOT, RIGHT'],
    ['MOLE FHD', 'FOREHEAD'],
    ['MOLE GROIN', 'GROIN AREA'],
    ['MOLE L HND', 'HAND, LEFT'],
    ['MOLE HAND', 'HAND, NONSPECIFIC'],
    ['MOLE R HND', 'HAND, RIGHT'],
    ['MOLE HEAD', 'HEAD, NONSPECIFIC'],
    ['MOLE L HIP', 'HIP, LEFT'],
    ['MOLE HIP', 'HIP, NONSPECIFIC'],
    ['MOLE R HIP', 'HIP, RIGHT'],
    ['MOLE L KNE', 'KNEE, LEFT'],
    ['MOLE KNEE', 'KNEE, NONSPECIFIC'],
    ['MOLE R KNE', 'KNEE, RIGHT'],
    ['MOLE L LEG', 'LEG, LEFT'],
    ['MOLE LEG', 'LEG, NONSPECIFIC'],
    ['MOLE R LEG', 'LEG, RIGHT'],
    ['MOLE L LIP', 'LIP, LOWER'],
    ['MOLE LIP', 'LIP, NONSPECIFIC'],
    ['MOLE U LIP', 'LIP, UPPER'],
    ['MOLE NECK', 'NECK'],
    ['MOLE NOSE', 'NOSE'],
    ['MOLE PENIS', 'PENIS'],
    ['MOLE L SHD', 'SHOULDER, LEFT'],
    ['MOLE SHLD', 'SHOULDER, NONSPECIFIC'],
    ['MOLE R SHD', 'SHOULDER, RIGHT'],
    ['MOLE L THG', 'THIGH, LEFT'],
    ['MOLE THGH', 'THIGH, NONSPECIFIC'],
    ['MOLE R THG', 'THIGH, RIGHT'],
    ['MOLE L TOE', 'TOE, LEFT'],
    ['MOLE TOE', 'TOE, NONSPECIFIC'],
    ['MOLE R TOE', 'TOE, RIGHT'],
    ['MOLE L WRS', 'WRIST, LEFT'],
    ['MOLE WRS', 'WRIST, NONSPECIFIC'],
    ['MOLE R WRS', 'WRIST, RIGHT']
];
exports.OPTIONS_SMT_NM = [
    ['NM L ANKL', 'ANKLE, LEFT'],
    ['NM ANKL ', 'ANKLE, NONSPECIFIC'],
    ['NM R ANKL', 'ANKLE, RIGHT'],
    ['NM L ARM', 'ARM, LEFT'],
    ['NM LL ARM', 'ARM, LEFT, LOWER'],
    ['NM UL ARM', 'ARM, LEFT, UPPER'],
    ['NM ARM  ', 'ARM, NONSPECIFIC'],
    ['NM R ARM', 'ARM, RIGHT'],
    ['NM LR ARM', 'ARM, RIGHT, LOWER'],
    ['NM UR ARM', 'ARM, RIGHT, UPPER'],
    ['NM L BUTTK', 'BUTTOCK, LEFT'],
    ['NM BUTTK', 'BUTTOCK, NONSPECIFIC'],
    ['NM R BUTTK', 'BUTTOCK, RIGHT'],
    ['NM L CALF', 'CALF, LEFT'],
    ['NM CALF ', 'CALF, NONSPECIFIC'],
    ['NM R CALF', 'CALF, RIGHT'],
    ['NM L ELB', 'ELBOW, LEFT'],
    ['NM ELBOW', 'ELBOW, NONSPECIFIC'],
    ['NM R ELB', 'ELBOW, RIGHT'],
    ['NM L FGR', 'FINGER(S), LEFT HAND'],
    ['NM FGR  ', 'FINGER(S), NONSPECIFIC'],
    ['NM R FGR', 'FINGER(S), RIGHT HAND'],
    ['NM L FOOT', 'FOOT, LEFT'],
    ['NM FOOT ', 'FOOT, NONSPECIFIC'],
    ['NM R FOOT', 'FOOT, RIGHT'],
    ['NM GROIN', 'GROIN, NONSPECIFIC'],
    ['NM L HND', 'HAND, LEFT'],
    ['NM HAND ', 'HAND, NONSPECIFIC'],
    ['NM R HND', 'HAND, RIGHT'],
    ['NM L HIP', 'HIP, LEFT'],
    ['NM HIP  ', 'HIP, NONSPECIFIC'],
    ['NM R HIP', 'HIP, RIGHT'],
    ['NM L KNE', 'KNEE, LEFT'],
    ['NM KNEE ', 'KNEE, NONSPECIFIC'],
    ['NM R KNE', 'KNEE, RIGHT'],
    ['NM L LEG', 'LEG, LEFT'],
    ['NM LEG  ', 'LEG, NONSPECIFIC'],
    ['NM R LEG', 'LEG, RIGHT'],
    ['NM PENIS', 'PENIS'],
    ['NM L SHLD', 'SHOULDER, LEFT'],
    ['NM SHLD ', 'SHOULDER, NONSPECIFIC'],
    ['NM R SHLD', 'SHOULDER, RIGHT'],
    ['NM L THIGH', 'THIGH, LEFT'],
    ['NM THIGH', 'THIGH, NONSPECIFIC'],
    ['NM R THIGH', 'THIGH, RIGHT'],
    ['NM TOE  ', 'TOE(S), NONSPECIFIC'],
    ['NM L TOE', 'TOE, LEFT'],
    ['NM R TOE', 'TOE, RIGHT'],
    ['NM L WRIST', 'WRIST, LEFT'],
    ['NM WRIST', 'WRIST, NONSPECIFIC'],
    ['NM R WRIST', 'WRIST, RIGHT']
];
exports.OPTIONS_SMT_OTHER = [
    ['GAUGING', 'GAUGING (STRETCHING, TAPERING, EXPANDING OF EARLOBE OR OTHER BODY PARTS)'],
    ['PRCD ABDMN', 'ABDOMEN, PIERCED'],
    ['PRCD BACK', 'BACK, PIERCED'],
    ['BALD', 'BALD/BALDING'],
    ['BODY MOD', 'BODY MODIFICATIONS (NOT OTHERWISE CODED)'],
    ['DIMP L CHK', 'CHEEK, LEFT, DIMPLES'],
    ['DIMP CHEEK', 'CHEEK, NONSPECIFIC, DIMPLE'],
    ['DIMP R CHK', 'CHEEK, RIGHT, DIMPLES'],
    ['PRCD CHIN', 'CHIN, PIERCED'],
    ['DIMP CHIN', 'DIMPLES, CHIN'],
    ['PRCD L EAR', 'EAR, LEFT, PIERCED'],
    ['PRCD EAR', 'EAR, NONSPECIFIC, PIERCED'],
    ['PRCD R EAR', 'EAR, RIGHT, PIERCED'],
    ['PRCD EARS', 'EARS, PIERCED'],
    ['PRCD L EYE', 'EYEBROW, LEFT, PIERCED'],
    ['PRCD EYE', 'EYEBROW, NONSPECIFIC, PIERCED'],
    ['PRCD R EYE', 'EYEBROW, RIGHT, PIERCED'],
    ['DIMP FACE', 'FACE, DIMPLE'],
    ['PRCD FACE', 'FACE, NONSPECIFIC, PIERCED'],
    ['FRECKLES', 'FRECKLES'],
    ['PRCD GNTLS', 'GENITALIA, PIERCED'],
    ['HAIR IMPL', 'HAIR IMPLANTS'],
    ['HERMAPHR', 'HERMAPHRODITE'],
    ['IDENT TWIN', 'IDENTICAL TWIN'],
    ['PRCD LLIP', 'LIP, LOWER, PIERCED'],
    ['PRCD LIP', 'LIP, NONSPECIFIC, PIERCED'],
    ['PRCD ULIP', 'LIP, UPPER, PIERCED'],
    ['MISS TEETH', 'MISSING TEETH (NOT TO BE USED IN PLACE OF SUPPLEMENTAL DENTAL RECORD)'],
    ['PRCD L NIP', 'NIPPLE, LEFT, PIERCED'],
    ['PRCD NIPPL', 'NIPPLE, NONSPECIFIC, PIERCED'],
    ['PRCD R NIP', 'NIPPLE, RIGHT, PIERCED'],
    ['NO TEETH', 'NO TEETH (ADULT ONLY)'],
    ['PRCD NOSE', 'NOSE, PIERCED'],
    ['TWIN', 'ONE OF TWO INDIVIDUALS PRODUCED BY THE SAME PREGNANCY'],
    ['PRCD BODY', 'PIERCED BODY (NOT OTHERWISE CODED)'],
    ['STUTTERS', 'STUTTERS'],
    ['GRILL', 'TEETH GRILL'],
    ['MULT BIRTH', 'THREE OR MORE SIBLINGS FROM SAME BIRTH'],
    ['PRCD TONGU', 'TONGUE, PIERCED'],
    [
        'TRANSSXL',
        'TRANSSEXUAL(MISCELLANEOUS FIELD SHOULD INDICATE WHAT THE INDIVIDUAL WAS AT BIRTH AND WHAT THEY ARE AT THE TIME THE RECORD IS ENTERED INTO NCIC.)'
    ],
    ['TRANSVST', 'TRANSVESTITE']
];
exports.OPTIONS_SMT_SCAR = [
    ['SC ABDOM', 'ABDOMEN'],
    ['SC L ANKL', 'ANKLE, LEFT'],
    ['SC ANKL', 'ANKLE, NONSPECIFIC'],
    ['SC R ANKL', 'ANKLE, RIGHT'],
    ['SC L ARM', 'ARM, LEFT'],
    ['SC LF ARM', 'ARM, LEFT, LOWER'],
    ['SC UL ARM', 'ARM, LEFT, UPPER'],
    ['SC ARM', 'ARM, NONSPECIFIC'],
    ['SC F ARM', 'ARM, NONSPECIFIC, LOWER'],
    ['SC R ARM', 'ARM, RIGHT'],
    ['SC RF ARM', 'ARM, RIGHT, LOWER'],
    ['SC UR ARM', 'ARM, RIGHT, UPPER'],
    ['SC BACK', 'BACK'],
    ['SC L BRST', 'BREAST, LEFT'],
    ['SC BREAST', 'BREAST, NONSPECIFIC'],
    ['SC R BRST', 'BREAST, RIGHT'],
    ['SC R BUTTK', 'BUTTOCK, RIGHT'],
    ['SC L BUTTK', 'BUTTOCKS, LEFT'],
    ['SC BUTTK', 'BUTTOCKS, NONSPECIFIC'],
    ['SC L CALF', 'CALF, LEFT'],
    ['SC CALF', 'CALF, NONSPECIFIC'],
    ['SC R CALF', 'CALF, RIGHT'],
    ['SC L CHK', 'CHEEK, LEFT'],
    ['SC CHK', 'CHEEK, NONSPECIFIC'],
    ['SC R CHK', 'CHEEK, RIGHT'],
    ['SC CHEST', 'CHEST'],
    ['SC CHIN', 'CHIN'],
    ['SC L EAR', 'EAR, LEFT'],
    ['SC EAR', 'EAR, NONSPECIFIC'],
    ['SC R EAR', 'EAR, RIGHT'],
    ['SC L ELB', 'ELBOW, LEFT'],
    ['SC ELBOW', 'ELBOW, NONSPECIFIC'],
    ['SC R ELB', 'ELBOW, RIGHT'],
    ['SC L EYE', 'EYEBROW, LEFT/LEFT EYE AREA'],
    ['SC EYE', 'EYEBROW, NONSPECIFIC'],
    ['SC R EYE', 'EYEBROW, RIGHT/RIGHT EYE AREA'],
    ['SC FACE', 'FACE, NONSPECIFIC'],
    ['SC L FGR', 'FINGER(S), LEFT HAND'],
    ['SC R FGR', 'FINGER(S), RIGHT HAND'],
    ['SC FGR', 'FINGER, NONSPECIFIC'],
    ['SC L FT', 'FOOT, LEFT'],
    ['SC FOOT', 'FOOT, NONSPECIFIC'],
    ['SC R FT', 'FOOT, RIGHT'],
    ['SC FHD', 'FOREHEAD'],
    ['SC GROIN', 'GROIN AREA'],
    ['SC L HND', 'HAND, LEFT'],
    ['SC HAND', 'HAND, NONSPECIFIC'],
    ['SC R HND', 'HAND, RIGHT'],
    ['SC HEAD', 'HEAD, NONSPECIFIC'],
    ['SC L HIP', 'HIP, LEFT'],
    ['SC HIP', 'HIP, NONSPECIFIC'],
    ['SC R HIP', 'HIP, RIGHT'],
    ['SC L KNEE', 'KNEE, LEFT'],
    ['SC KNEE', 'KNEE, NONSPECIFIC'],
    ['SC R KNEE', 'KNEE, RIGHT'],
    ['SC L LEG', 'LEG, LEFT'],
    ['SC LEG', 'LEG, NONSPECIFIC'],
    ['SC R LEG', 'LEG, RIGHT'],
    ['SC LOW LIP', 'LIP, LOWER'],
    ['SC LIP', 'LIP, NONSPECIFIC'],
    ['SC UP LIP', 'LIP, UPPER'],
    ['SC NECK', 'NECK'],
    ['SC NOSE', 'NOSE'],
    ['SC PENIS', 'PENIS'],
    ['POCKMARKS', 'POCKMARKS'],
    ['SC L SHLD', 'SHOULDER, LEFT'],
    ['SC SHLD', 'SHOULDER, NONSPECIFIC'],
    ['SC R SHLD', 'SHOULDER, RIGHT'],
    ['SC L THGH', 'THIGH, LEFT'],
    ['SC THGH', 'THIGH, NONSPECIFIC'],
    ['SC R THGH', 'THIGH, RIGHT'],
    ['SC TOE', 'TOE(S), NONSPECIFIC'],
    ['SC L TOE', 'TOE, LEFT'],
    ['SC R TOE', 'TOE, RIGHT'],
    ['SC L WRIST', 'WRIST, LEFT'],
    ['SC WRIST', 'WRIST, NONSPECIFIC'],
    ['SC R WRIST', 'WRIST, RIGHT']
];
exports.OPTIONS_SMT_DISC = [
    ['DISC ABDOM', 'ABDOMEN'],
    ['DISC L ANK', 'ANKLE, LEFT'],
    ['DISC ANKL', 'ANKLE, NONSPECIFIC'],
    ['DISC R ANK', 'ANKLE, RIGHT'],
    ['DISC L ARM', 'ARM, LEFT'],
    ['DISC LFARM', 'ARM, LEFT, LOWER'],
    ['DISC ULARM', 'ARM, LEFT, UPPER'],
    ['DISC ARM', 'ARM, NONSPECIFIC'],
    ['DISC F ARM', 'ARM, NONSPECIFIC, LOWER'],
    ['DISC R ARM', 'ARM, RIGHT'],
    ['DISC RFARM', 'ARM, RIGHT, LOWER'],
    ['DISC URARM', 'ARM, RIGHT, UPPER'],
    ['DISC BACK', 'BACK'],
    ['DISC L BRS', 'BREAST, LEFT'],
    ['DISC BRST', 'BREAST, NONSPECIFIC'],
    ['DISC R BRS', 'BREAST, RIGHT'],
    ['DISC L BUT', 'BUTTOCK, LEFT'],
    ['DISC R BUT', 'BUTTOCK, RIGHT'],
    ['DISC BUTTK', 'BUTTOCKS, NONSPECIFIC'],
    ['DISC LCALF', 'CALF, LEFT'],
    ['DISC CALF', 'CALF, NONSPECIFIC'],
    ['DISC RCALF', 'CALF, RIGHT'],
    ['DISC L CHK', 'CHEEK, LEFT'],
    ['DISC CHEEK', 'CHEEK, NONSPECIFIC'],
    ['DISC R CHK', 'CHEEK, RIGHT'],
    ['DISC CHEST', 'CHEST'],
    ['DISC CHIN', 'CHIN'],
    ['DISC L EAR', 'EAR, LEFT'],
    ['DISC EAR', 'EAR, NONSPECIFIC'],
    ['DISC R EAR', 'EAR, RIGHT'],
    ['DISC L ELB', 'ELBOW, LEFT'],
    ['DISC ELBOW', 'ELBOW, NONSPECIFIC'],
    ['DISC R ELB', 'ELBOW, RIGHT'],
    ['DISC L EYE', 'EYEBROW, LEFT/LEFT EYE AREA'],
    ['DISC EYE', 'EYEBROW, NONSPECIFIC'],
    ['DISC R EYE', 'EYEBROW, RIGHT/RIGHT EYE AREA'],
    ['DISC FACE', 'FACE, NONSPECIFIC'],
    ['DISC L FGR', 'FINGER(S), LEFT HAND'],
    ['DISC R FGR', 'FINGER(S), RIGHT HAND'],
    ['DISC FGR', 'FINGER, NONSPECIFIC'],
    ['DISC L FT', 'FOOT, LEFT'],
    ['DISC FOOT', 'FOOT, NONSPECIFIC'],
    ['DISC R FT', 'FOOT, RIGHT'],
    ['DISC FHD', 'FOREHEAD'],
    ['DISC GROIN', 'GROIN, NONSPECIFIC'],
    ['DISC L HND', 'HAND, LEFT'],
    ['DISC HAND', 'HAND, NONSPECIFIC'],
    ['DISC R HND', 'HAND, RIGHT'],
    ['DISC HEAD', 'HEAD'],
    ['DISC L HIP', 'HIP, LEFT'],
    ['DISC HIP', 'HIP, NONSPECIFIC'],
    ['DISC R HIP', 'HIP, RIGHT'],
    ['DISC LKNEE', 'KNEE, LEFT'],
    ['DISC KNEE', 'KNEE, NONSPECIFIC'],
    ['DISC RKNEE', 'KNEE, RIGHT'],
    ['DISC L LEG', 'LEG, LEFT'],
    ['DISC LEG', 'LEG, NONSPECIFIC'],
    ['DISC R LEG', 'LEG, RIGHT'],
    ['DISC L LIP', 'LIP, LOWER'],
    ['DISC LIP', 'LIP, NONSPECIFIC'],
    ['DISC U LIP', 'LIP, UPPER'],
    ['DISC NECK', 'NECK'],
    ['DISC NOSE', 'NOSE'],
    ['DISC PENIS', 'PENIS'],
    ['DISC LSHLD', 'SHOULDER, LEFT'],
    ['DISC SHLD', 'SHOULDER, NONSPECIFIC'],
    ['DISC RSHLD', 'SHOULDER, RIGHT'],
    ['DISC LTHGH', 'THIGH, LEFT'],
    ['DISC THGH', 'THIGH, NONSPECIFIC'],
    ['DISC RTHGH', 'THIGH, RIGHT'],
    ['DISC TOE', 'TOE(S), NONSPECIFIC'],
    ['DISC L TOE', 'TOE, LEFT'],
    ['DISC R TOE', 'TOE, RIGHT'],
    ['DISC L WRS', 'WRIST, LEFT'],
    ['DISC WRIST', 'WRIST, NONSPECIFIC'],
    ['DISC R WRS', 'WRIST, RIGHT']
];
exports.OPTIONS_SMT_TATTOO = [
    ['TAT ABDOM', 'ABDOMEN'],
    ['TAT L ANKL', 'ANKLE, LEFT'],
    ['TAT ANKL', 'ANKLE, NONSPECIFIC'],
    ['TAT R ANKL', 'ANKLE, RIGHT'],
    ['TAT L ARM', 'ARM, LEFT'],
    ['TAT LF ARM', 'ARM, LEFT, LOWER'],
    ['TAT UL ARM', 'ARM, LEFT, UPPER'],
    ['TAT ARM', 'ARM, NONSPECIFIC'],
    ['TAT FARM', 'ARM, NONSPECIFIC, LOWER'],
    ['TAT R ARM', 'ARM, RIGHT'],
    ['TAT RF ARM', 'ARM, RIGHT, LOWER'],
    ['TAT UR ARM', 'ARM, RIGHT, UPPER'],
    ['TAT BACK', 'BACK'],
    ['TAT L BRST', 'BREAST, LEFT'],
    ['TAT BREAST', 'BREAST, NONSPECIFIC'],
    ['TAT R BRST', 'BREAST, RIGHT'],
    ['TAT L BUTK', 'BUTTOCK, LEFT'],
    ['TAT R BUTK', 'BUTTOCK, RIGHT'],
    ['TAT BUTTK', 'BUTTOCKS, NONSPECIFIC'],
    ['TAT L CALF', 'CALF, LEFT'],
    ['TAT CALF', 'CALF, NONSPECIFIC'],
    ['TAT R CALF', 'CALF, RIGHT'],
    ['TAT L CHK', 'CHEEK, LEFT'],
    ['TAT CHEEK', 'CHEEK, NONSPECIFIC'],
    ['TAT R CHK', 'CHEEK, RIGHT'],
    ['TAT CHEST', 'CHEST'],
    ['TAT CHIN', 'CHIN'],
    ['TAT L EAR', 'EAR, LEFT'],
    ['TAT EAR', 'EAR, NONSPECIFIC'],
    ['TAT R EAR', 'EAR, RIGHT'],
    ['TAT LELBOW', 'ELBOW, LEFT'],
    ['TAT ELBOW', 'ELBOW, NONSPECIFIC'],
    ['TAT RELBOW', 'ELBOW, RIGHT'],
    ['TAT L EYE', 'EYE, LEFT'],
    ['TAT EYE', 'EYE, NONSPECIFIC'],
    ['TAT R EYE', 'EYE, RIGHT'],
    ['TAT FACE', 'FACE, NONSPECIFIC'],
    ['TAT L FGR', 'FINGER(S), LEFT HAND'],
    ['TAT R FGR', 'FINGER(S), RIGHT HAND'],
    ['TAT FNGR', 'FINGER, NONSPECIFIC'],
    ['TAT L FOOT', 'FOOT, LEFT'],
    ['TAT FOOT', 'FOOT, NONSPECIFIC'],
    ['TAT R FOOT', 'FOOT, RIGHT'],
    ['TAT FHD', 'FOREHEAD'],
    ['TAT FLBODY', 'FULL BODY'],
    ['TAT GROIN', 'GROIN AREA'],
    ['TAT L HND', 'HAND, LEFT'],
    ['TAT HAND', 'HAND, NONSPECIFIC'],
    ['TAT R HND', 'HAND, RIGHT'],
    ['TAT HEAD', 'HEAD, NONSPECIFIC'],
    ['TAT L HIP', 'HIP, LEFT'],
    ['TAT HIP', 'HIP, NONSPECIFIC'],
    ['TAT R HIP', 'HIP, RIGHT'],
    ['TAT L KNEE', 'KNEE, LEFT'],
    ['TAT KNEE', 'KNEE, NONSPECIFIC'],
    ['TAT R KNEE', 'KNEE, RIGHT'],
    ['TAT L LEG', 'LEG, LEFT'],
    ['TAT LEG', 'LEG, NONSPECIFIC'],
    ['TAT R LEG', 'LEG, RIGHT'],
    ['TAT LW LIP', 'LIP, LOWER'],
    ['TAT LIP', 'LIP, NONSPECIFIC'],
    ['TAT UP LIP', 'LIP, UPPER'],
    ['TAT NECK', 'NECK'],
    ['TAT NOSE', 'NOSE'],
    ['TAT PENIS', 'PENIS'],
    ['TAT L SHLD', 'SHOULDER, LEFT'],
    ['TAT SHLD', 'SHOULDER, NONSPECIFIC'],
    ['TAT R SHLD', 'SHOULDER, RIGHT'],
    ['TAT L THGH', 'THIGH, LEFT'],
    ['TAT THGH', 'THIGH, NONSPECIFIC'],
    ['TAT R THGH', 'THIGH, RIGHT'],
    ['TAT TOE', 'TOE(S), NONSPECIFIC'],
    ['TAT L TOE', 'TOE, LEFT'],
    ['TAT R TOE', 'TOE, RIGHT'],
    ['TAT L WRS', 'WRIST, LEFT'],
    ['TAT WRS', 'WRIST, NONSPECIFIC'],
    ['TAT R WRS', 'WRIST, RIGHT']
];
exports.OPTIONS_SMT_ART = [
    ['ART L ARM', 'ARM, LEFT, ARTIFICIAL'],
    ['BRAC L ARM', 'ARM, LEFT, BRACE'],
    ['ART ARM', 'ARM, NONSPECIFIC, ARTIFICIAL'],
    ['BRAC ARM', 'ARM, NONSPECIFIC, BRACE'],
    ['ART R ARM', 'ARM, RIGHT, ARTIFICIAL'],
    ['BRAC R ARM', 'ARM, RIGHT, BRACE'],
    ['BRA LR ARM', 'ARMS, LEFT AND RIGHT, BRACE'],
    ['BRACE BACK', 'BACK, BRACE'],
    ['ART L BRST', 'BREAST IMPLANT, LEFT'],
    ['ART BRSTS', 'BREAST IMPLANT, LEFT AND RIGHT'],
    ['ART BRST', 'BREAST IMPLANT, NONSPECIFIC, ARTIFICIAL'],
    ['ART R BRST', 'BREAST IMPLANT, RIGHT'],
    ['CANE', 'CANE'],
    ['CON LENSES', 'CONTACT LENSES'],
    ['CRUTCHES', 'CRUTCHES'],
    ['DENT LOW', 'DENTURE, LOWER ONLY'],
    ['DENT UP LO', 'DENTURE, UPPER AND LOWER'],
    ['DENT UP', 'DENTURE, UPPER ONLY'],
    ['ART L EAR', 'EAR, LEFT, ARTIFICIAL'],
    ['ART EAR', 'EAR, NONSPECIFIC, ARTIFICIAL'],
    ['ART R EAR', 'EAR, RIGHT, ARTIFICIAL'],
    ['ART L ELB', 'ELBOW, LEFT, ARTIFICIAL'],
    ['ART ELBOW', 'ELBOW, NONSPECIFIC, ARTIFICIAL'],
    ['ART R ELB', 'ELBOW, RIGHT, ARTIFICIAL'],
    ['ART L EYE', 'EYE, LEFT, ARTIFICIAL'],
    ['ART EYE', 'EYE, NONSPECIFIC, ARTIFICIAL'],
    ['ART R EYE', 'EYE, RIGHT, ARTIFICIAL'],
    ['ART L FT', 'FOOT, LEFT, ARTIFICIAL'],
    ['ART FOOT', 'FOOT, NONSPECIFIC, ARTIFICIAL'],
    ['ART R FT', 'FOOT, RIGHT, ARTIFICIAL'],
    ['GLASSES', 'GLASSES (PRESCRIPTION)'],
    ['GOLD TOOTH', 'GOLD TOOTH'],
    ['ART L HND', 'HAND, LEFT, ARTIFICIAL'],
    ['ART HAND', 'HAND, NONSPECIFIC, ARTIFICIAL'],
    ['ART R HND', 'HAND, RIGHT, ARTIFICIAL'],
    ['HEAR AID', 'HEARING AID'],
    ['ART HIP', 'HIP JOINT, ARTIFICIAL'],
    ['ART L HIP', 'HIP, LEFT, ARTIFICIAL'],
    ['ART R HIP', 'HIP, RIGHT, ARTIFICIAL'],
    ['ART KNEE', 'KNEE JOINT, ARTIFICIAL'],
    ['ART L KNE', 'KNEE, LEFT, ARTIFICIAL'],
    ['ART R KNE', 'KNEE, RIGHT, ARTIFICIAL'],
    ['ART LARYNX', 'LARYNX, ARTIFICIAL'],
    ['ART L LEG', 'LEG, LEFT, ARTIFICIAL'],
    ['BRAC L LEG', 'LEG, LEFT, BRACE'],
    ['ART LEG', 'LEG, NONSPECIFIC, ARTIFICIAL'],
    ['BRAC LEG', 'LEG, NONSPECIFIC, BRACE'],
    ['ART R LEG', 'LEG, RIGHT, ARTIFICIAL'],
    ['BRAC R LEG', 'LEG, RIGHT, BRACE'],
    ['BRA LR LEG', 'LEGS, LEFT AND RIGHT, BRACE'],
    ['BRACE NECK', 'NECK, BRACE'],
    ['ART L SHLD', 'SHOULDER, LEFT, ARTIFICIAL'],
    ['ART SHLD', 'SHOULDER, NONSPECIFIC, ARTIFICIAL'],
    ['ART R SHLD', 'SHOULDER, RIGHT, ARTIFICIAL'],
    ['BRAC TEETH', 'TEETH, BRACE'],
    ['SLVR TOOTH', 'TOOTH, SILVER'],
    ['WHEELCHAIR', 'WHEELCHAIR']
];
exports.OPTIONS_SMT_DEAF = [
    ['DEAF L EAR', 'EAR, LEFT, DEAF'],
    ['DEAF EAR', 'EAR, NONSPECIFIC, DEAF'],
    ['DEAF R EAR', 'EAR, RIGHT, DEAF'],
    ['DEAF MUTE', 'EARS, DEAF-MUTE'],
    ['DEAF', 'EARS, LEFT AND RIGHT, DEAF']
];
exports.OPTIONS_SMT_DEFORM = [
    ['CRIP L ARM', 'ARM, LEFT, CRIPPLED'],
    ['CRIP ARM', 'ARM, NONSPECIFIC, CRIPPLED'],
    ['CRIP R ARM', 'ARM, RIGHT, CRIPPLED'],
    ['EXTR CBRST', 'BREAST, CENTER, EXTRA'],
    ['EXTR LBRST', 'BREAST, LEFT, EXTRA'],
    ['EXTR BRST', 'BREAST, NONSPECIFIC, EXTRA'],
    ['EXTR RBRST', 'BREAST, RIGHT, EXTRA'],
    ['CLEFT CHIN', 'CHIN, CLEFT'],
    ['DEV SEPTUM', 'DEVIATED SEPTUM'],
    ['CAUL L EAR', 'EAR, LEFT, CAULIFLOWER'],
    ['CAUL EAR', 'EAR, NONSPECIFIC, CAULIFLOWER'],
    ['CAUL R EAR', 'EAR, RIGHT, CAULIFLOWER'],
    ['CRIP L FGR', 'FINGER(S), LEFT HAND (INCLUDES WEBBED FINGERS), CRIPPLED'],
    ['EXTR L FGR', 'FINGER(S), LEFT HAND, EXTRA'],
    ['CRIP FGR', 'FINGER(S), NONSPECIFIC, CRIPPLED'],
    ['EXTR FGR', 'FINGER(S), NONSPECIFIC, EXTRA'],
    ['CRIP R FGR', 'FINGER(S), RIGHT HAND (INCLUDES WEBBED FINGERS), CRIPPLED'],
    ['EXTR R FGR', 'FINGER(S), RIGHT HAND, EXTRA'],
    ['CRIP L FT', 'FOOT, LEFT (INCLUDES CLUBFOOT), CRIPPLED'],
    ['CRIP FOOT', 'FOOT, NONSPECIFIC, CRIPPLED'],
    ['CRIP R FT', 'FOOT, RIGHT (INCLUDES CLUBFOOT), CRIPPLED'],
    ['CRIP L HND', 'HAND, LEFT, CRIPPLED'],
    ['CRIP HAND', 'HAND, NONSPECIFIC, CRIPPLED'],
    ['CRIP R HND', 'HAND, RIGHT, CRIPPLED'],
    ['HUMPBACKED', 'HUMPBACKED'],
    ['PROT L JAW', 'JAW, LOWER, PROTRUDING'],
    ['PROT JAW', 'JAW, NONSPECIFIC, PROTRUDING'],
    ['PROT U JAW', 'JAW, UPPER, PROTRUDING'],
    ['CRIP L LEG', 'LEG, LEFT, CRIPPLED'],
    ['SHRT L LEG', 'LEG, LEFT, SHORTER'],
    ['CRIP LEG', 'LEG, NONSPECIFIC, CRIPPLED'],
    ['SHRT LEG', 'LEG, NONSPECIFIC, SHORTER'],
    ['CRIP R LEG', 'LEG, RIGHT, CRIPPLED'],
    ['SHRT R LEG', 'LEG, RIGHT, SHORTER'],
    ['CL LIP', 'LIP, CLEFT'],
    ['MUTE', 'MUTE (USE IF PERSON IS MUTE BUT NOT DEAF.)'],
    ['EXTR C NIP', 'NIPPLE, CENTER, EXTRA'],
    ['EXTR L NIP', 'NIPPLE, LEFT, EXTRA'],
    ['EXTR NIP', 'NIPPLE, NONSPECIFIC, EXTRA'],
    ['EXTR R NIP', 'NIPPLE, RIGHT, EXTRA'],
    ['CLEFT PAL', 'PALATE, CLEFT'],
    ['CRIP L TOE', 'TOE(S), LEFT (INCLUDES WEBBED TOES), CRIPPLED'],
    ['EXTR L TOE', 'TOE(S), LEFT, EXTRA'],
    ['CRIP TOE', 'TOE(S), NONSPECIFIC, CRIPPLED'],
    ['EXTR TOE', 'TOE(S), NONSPECIFIC, EXTRA'],
    ['CRIP R TOE', 'TOE(S), RIGHT (INCLUDES WEBBED TOES), CRIPPLED'],
    ['EXTR R TOE', 'TOE(S), RIGHT, EXTRA'],
    ['EXTR L TTH', 'TOOTH/TEETH, LOWER JAW, EXTRA'],
    ['EXTR TTH', 'TOOTH/TEETH, NONSPECIFIC, EXTRA'],
    ['EXTR U TTH', 'TOOTH/TEETH, UPPER JAW, EXTRA'],
    ['EXTR C VRT', 'VERTEBRAE, CERVICAL, EXTRA'],
    ['EXTR L VRT', 'VERTEBRAE, LUMBAR, EXTRA'],
    ['EXTR VRT', 'VERTEBRAE, NONSPECIFIC, EXTRA']
];
exports.OPTIONS_SMT_DRUGS = [
    ['DA ALCOHOL', 'ALCOHOL'],
    ['DA AMPHETA', 'AMPHETAMINES (INCLUDES STIMULANTS,SPEED, ETC.)'],
    ['DA BARBITU', 'BARBITURATES'],
    ['DA COCAINE', 'COCAINE (INCLUDES CRACK)'],
    ['DA GLUE', 'GLUE'],
    ['DA HALLUCI', 'HALLUCINOGENS'],
    ['DA MARIJUA', 'MARIJUANA'],
    ['DA NARCOTI', 'NARCOTICS (INCLUDES HEROIN,MORPHINE, DILAUDID, METHADONE,ETC.)'],
    ['DA OTHER', 'OTHER DRUGS OF ABUSE NOT LISTED ABOVE, IDENTIFY IN THE MISCELLANEOUS (MIS) FIELD'],
    ['DA PAINT', 'PAINT (INCLUDES THINNER)'],
    ['DA RITALIN', 'RITALIN'],
    ['DA ROHYPNL', 'ROHYPNOL (BRAND NAME FOR FLUNITRAZEPAM, ALSO REFERRED TO AS ROPHIES, ROOFIES, RUFFIES, AND ROCHE)']
];
exports.OPTIONS_SMT_EYE = [
    ['AMBL EYE', 'AMBLYOPIA (COMMONLY REFERRED TO AS LAZY EYE), ONE EYE NON SPECIFIC'],
    ['AMBL L EYE', 'AMBLYOPIA, LEFT EYE'],
    ['AMBL R EYE', 'AMBLYOPIA, RIGHT EYE'],
    ['EYE DISORD', 'EYE DISORDERS (NOT OTHERWISE CODED)'],
    ['BLND L EYE', 'EYE, LEFT, BLIND'],
    ['CATA L EYE', 'EYE, LEFT, CATARACT'],
    ['BLND EYE', 'EYE, NONSPECIFIC, BLIND'],
    ['CATARACT', 'EYE, NONSPECIFIED, CATARACT'],
    ['BLND R EYE', 'EYE, RIGHT, BLIND'],
    ['CATA R EYE', 'EYE, RIGHT, CATARACT'],
    ['BLIND', 'EYES, BOTH, BLIND'],
    ['CROSSEYED', 'EYES, CROSSED'],
    ['GLAUCOMA', 'GLAUCOMA']
];
exports.OPTIONS_SMT_FRACTURE = [
    ['FRC L ANKL', 'ANKLE, LEFT'],
    ['FRC ANKL', 'ANKLE, NONSPECIFIC'],
    ['FRC R ANKL', 'ANKLE, RIGHT'],
    ['FRC L ARM', 'ARM, LEFT'],
    ['FRC LL ARM', 'ARM, LEFT, LOWER'],
    ['FRC UL ARM', 'ARM, LEFT, UPPER'],
    ['FRC ARM', 'ARM, NONSPECIFIC'],
    ['FRC R ARM', 'ARM, RIGHT'],
    ['FRC LR ARM', 'ARM, RIGHT, LOWER'],
    ['FRC UR ARM', 'ARM, RIGHT, UPPER'],
    ['FRC BACK', 'BACK'],
    ['FRC LCLAVI', 'CLAVICLE, LEFT'],
    ['FRC CLAVIC', 'CLAVICLE, NONSPECIFIC'],
    ['FRC RCLAVI', 'CLAVICLE, RIGHT'],
    ['FRC L ELB', 'ELBOW, LEFT'],
    ['FRC ELBOW', 'ELBOW, NONSPECIFIC'],
    ['FRC R ELB', 'ELBOW, RIGHT'],
    ['FRC L FGR', 'FINGER(S), LEFT HAND'],
    ['FRC FGR', 'FINGER(S), NONSPECIFIC'],
    ['FRC R FGR', 'FINGER(S), RIGHT HAND'],
    ['FRC L FOOT', 'FOOT, LEFT'],
    ['FRC FOOT', 'FOOT, NONSPECIFIC'],
    ['FRC R FOOT', 'FOOT, RIGHT'],
    ['FRC L HAND', 'HAND, LEFT'],
    ['FRC HAND', 'HAND, NONSPECIFIC'],
    ['FRC R HAND', 'HAND, RIGHT'],
    ['FRC L HIP', 'HIP, LEFT'],
    ['FRC HIP', 'HIP, NONSPECIFIC'],
    ['FRC R HIP', 'HIP, RIGHT'],
    ['FRC UL JAW', 'JAW, LEFT, UPPER'],
    ['FRC LL JAW', 'JAW, LOWER LEFT'],
    ['FRC LR JAW', 'JAW, LOWER RIGHT'],
    ['FRC JAW', 'JAW, NONSPECIFIC'],
    ['FRC UR JAW', 'JAW, RIGHT, UPPER'],
    ['FRC L KNEE', 'KNEE, LEFT'],
    ['FRC KNEE', 'KNEE, NONSPECIFIC'],
    ['FRC R KNEE', 'KNEE, RIGHT'],
    ['FRC L LEG', 'LEG, LEFT'],
    ['FRC LL LEG', 'LEG, LEFT, LOWER'],
    ['FRC UL LEG', 'LEG, LEFT, UPPER'],
    ['FRC LEG', 'LEG, NONSPECIFIC'],
    ['FRC R LEG', 'LEG, RIGHT'],
    ['FRC LR LEG', 'LEG, RIGHT, LOWER'],
    ['FRC UR LEG', 'LEG, RIGHT, UPPER'],
    ['FRC NECK', 'NECK'],
    ['FRC NOSE', 'NOSE'],
    ['FRC LPELVI', 'PELVIS BONE, LEFT'],
    ['FRC RPELVI', 'PELVIS BONE, RIGHT'],
    ['FRC PELVIS', 'PELVIS, NONSPECIFIC'],
    ['FRC L RIB', 'RIB(S), LEFT'],
    ['FRC RIBS', 'RIB(S), NONSPECIFIC'],
    ['FRC R RIB', 'RIB(S), RIGHT'],
    ['FRC L SHLD', 'SHOULDER, LEFT'],
    ['FRC SHLD', 'SHOULDER, NONSPECIFIC'],
    ['FRC R SHLD', 'SHOULDER, RIGHT'],
    ['FRC SKULL', 'SKULL'],
    ['FRC SPINE', 'SPINE'],
    ['FRC STERN', 'STERNUM'],
    ['FRC L TOE', 'TOE(S), LEFT FOOT'],
    ['FRC TOE', 'TOE(S), NONSPECIFIC'],
    ['FRC R TOE', 'TOE(S), RIGHT FOOT'],
    ['FRC L WRST', 'WRIST, LEFT'],
    ['FRC WRIST', 'WRIST, NONSPECIFIC'],
    ['FRC R WRST', 'WRIST, RIGHT']
];
exports.OPTIONS_SMT_COND = [
    ['MC ACNE', 'ACNE'],
    ['MC ALCOHOL', 'ALCOHOLISM'],
    ['MC ALLERGY', 'ALLERGIES INCLUDING ASTHMA'],
    ['MC ALZHMRS', "ALZHEIMER'S DISEASE"],
    ['MC ARTHRTS', 'ARTHRITIS'],
    ['MC ADD', 'ATTENTION DEFICIT DISORDER'],
    ['MC BEHAVIO', 'BEHAVIOR DISORDER(INCLUDES AUTISM, DEPRESSION,SCHIZOPHRENIA, SUICIDAL TENDENCIES(PAST AND PRESENT)'],
    ['MC CANCER', 'CANCER'],
    ['MC DIABTIC', 'DIABETIC'],
    ['MC DOWNSYN', "DOWN'S SYNDROME"],
    ['MC DRUGAB', 'DRUG ABUSE'],
    ['MC EATDIS', 'EATING DISORDERS (INCLUDES ANOREXIA, NERVOSA, ANDBULIMIA)'],
    [
        'MC HEART',
        'HEART OR CIRCULATORY DISEASESINCLUDING: HIGH BLOOD PRESSURE,HEART FAILURE, HEART ATTACK,HARDENING OF THE ARTERIES, ANDCIRCULATION PROBLEMS'
    ],
    [
        'MC BLOOD',
        'HEMATOLOGICAL DISEASES (DISEASE OFTHE BLOOD - INCLUDES: ANEMIA,HEMOPHILIA, LEUKEMIA, AND SICKLECELL ANEMIA)'
    ],
    ['MC KIDNEY', 'KIDNEY CONDITIONS OR DISEASES'],
    ['MC LIVER', 'LIVER DISEASE (INCLUDING CIRRHOSIS ANDHEPATITIS)'],
    ['MC NERVOUS', 'NERVOUS CONDITIONS INCLUDING:SEIZURES, STROKE, SENILITY, ANDMENTAL RETARDATION'],
    [
        'MC NRLGCAL',
        "NEUROLOGICAL CONDITIONS OR DISEASES (INCLUDES CEREBRAL PALSY, EPILEPSY, MULTIPLE SCLEROSIS, PARKINSON'S DISEASE)"
    ],
    ['MC OTHER', 'OTHER MEDICAL DISORDERS/CONDITIONSNOT LISTED ABOVE, IDENTIFY IN THEMISCELLANEOUS (MIS) FIELD'],
    ['MC PARPLGC', 'PARAPLEGIC'],
    ['MC PASTPRE', 'PREGNANCY - PAST'],
    ['MC PREGNAN', 'PREGNANCY - PRESENT'],
    ['MC PLMNARY', 'PULMONARY (LUNG) DISEASES (INCLUDES EMPHESYMA, CYSTICFIBROSIS)'],
    ['MC QUADPLG', 'QUADRIPLEGIC'],
    ['MC SKIN', 'SKIN DISORDERS(INCLUDES PSORIASIS AND ECZEMA)'],
    ['MC THYROID', 'THYROID CONDITIONS OR DISEASES'],
    ['MC TOURETE', "TOURETTE'S SYNDROME"],
    ['MC TB', 'TUBERCULOSIS']
];
exports.OPTIONS_SMT_DEVICE = [
    ['CARD PACEM', 'CARDIAC PACEMAKER'],
    ['COLOST APP', 'COLOSTOMY APPLIANCES'],
    ['TUBE L EAR', 'EAR, LEFT, TUBE'],
    ['TUBE R EAR', 'EAR, RIGHT, TUBE'],
    ['EAR TUBES', 'EARS, TUBES, LEFT AND RIGHT'],
    ['IMPLANT', 'IMPLANTS (INCLUDING MICRODERMAL, SUBDERMAL, TRANSDERMAL, BRAILLE TATTOO, BODY MONITORING DEVICE)'],
    ['INTRA ROD', 'INTRAMEDULLARY ROD'],
    ['IUD', 'INTRAUTERINE DEVICE'],
    ['MED PUMP', 'MEDICAL PUMPS (INCLUDING INSULIN PUMP AND DRUG PUMP)'],
    ['ORTH NAIL', 'ORTHOPEDIC NAIL OR PIN'],
    ['ORTH PLATE', 'ORTHOPEDIC PLATE'],
    ['ORTH SCREW', 'ORTHOPEDIC SCREW'],
    ['IMPL PENIS', 'PENILE IMPLANT'],
    ['SHUNT ART', 'SHUNT, ARTERIAL VASCULAR'],
    ['SHUNT CERB', 'SHUNT, CEREBRAL VENTRICULE'],
    ['SKL PLATE', 'SKULL PLATE'],
    ['STAPLES', 'STAPLES'],
    ['VASC PROTH', 'VASCULAR PROSTHESIS'],
    ['WIRE SUTUR', 'WIRE SUTURES']
];
exports.OPTIONS_SMT_MISSING = [
    ['MISS ADND', 'ADENOIDS'],
    ['MISS APPNX', 'APPENDIX'],
    ['MISS L ARM', 'ARM, LEFT'],
    ['MISS LLARM', 'ARM, LEFT, LOWER'],
    ['MISS ARM', 'ARM, NONSPECIFIC'],
    ['MISS R ARM', 'ARM, RIGHT'],
    ['MISS LRARM', 'ARM, RIGHT, LOWER'],
    ['MISS LBRST', 'BREAST, LEFT'],
    ['MISS BRST', 'BREAST, NONSPECIFIC'],
    ['MISS RBRST', 'BREAST, RIGHT'],
    ['MISS BRSTS', 'BREASTS, BOTH'],
    ['MISS L EAR', 'EAR, LEFT'],
    ['MISS EAR', 'EAR, NONSPECIFIC'],
    ['MISS R EAR', 'EAR, RIGHT'],
    ['MISS L EYE', 'EYE, LEFT'],
    ['MISS EYE', 'EYE, NONSPECIFIC'],
    ['MISS R EYE', 'EYE, RIGHT'],
    ['MISS L FJT', 'FINGER JOINT(S), LEFT HAND'],
    ['MISS R FJT', 'FINGER JOINT(S), RIGHT HAND'],
    ['MISS FJT', 'FINGER JOINT, NONSPECIFIC'],
    ['MISS L FGR', 'FINGER(S), LEFT HAND'],
    ['MISS FGR', 'FINGER(S), NONSPECIFIC'],
    ['MISS R FGR', 'FINGER(S), RIGHT HAND'],
    ['MISS L FT', 'FOOT, LEFT'],
    ['MISS FOOT', 'FOOT, NONSPECIFIC'],
    ['MISS R FT', 'FOOT, RIGHT'],
    ['MISS GALL', 'GALLBLADDER'],
    ['MISS L HND', 'HAND, LEFT'],
    ['MISS HAND', 'HAND, NONSPECIFIC'],
    ['MISS R HND', 'HAND, RIGHT'],
    ['MISS INTES', 'INTESTINES'],
    ['MISS L KID', 'KIDNEY, LEFT'],
    ['MISS KID', 'KIDNEY, NONSPECIFIC'],
    ['MISS R KID', 'KIDNEY, RIGHT'],
    ['MISS LRYNX', 'LARYNX'],
    ['MISS L LEG', 'LEG, LEFT'],
    ['MISS LLLEG', 'LEG, LEFT, LOWER'],
    ['MISS LEG', 'LEG, NONSPECIFIC'],
    ['MISS R LEG', 'LEG, RIGHT'],
    ['MISS LRLEG', 'LEG, RIGHT, LOWER'],
    ['MISS LLUNG', 'LUNG, LEFT'],
    ['MISS LUNG', 'LUNG, NONSPECIFIC'],
    ['MISS RLUNG', 'LUNG, RIGHT'],
    ['MISS NOSE', 'NOSE'],
    ['MISS OVARS', 'OVARIES'],
    ['MISS LOVAR', 'OVARY, LEFT'],
    ['MISS OVARY', 'OVARY, NONSPECIFIC'],
    ['MISS ROVAR', 'OVARY, RIGHT'],
    ['MISS PANCR', 'PANCREAS'],
    ['MISS PENIS', 'PENIS'],
    ['MISS PROST', 'PROSTATE GLAND'],
    ['MISS SPLEN', 'SPLEEN'],
    ['MISS STOMA', 'STOMACH'],
    ['MISS TES', 'TESTICAL, NONSPECIFIC'],
    ['MISS L TES', 'TESTIS, LEFT'],
    ['MISS R TES', 'TESTIS, RIGHT'],
    ['MISS THYRD', 'THYROID'],
    ['MISS TOE', 'TOE(S), NONSPECIFIC'],
    ['MISS L TOE', 'TOE(S), LEFT FOOT'],
    ['MISS R TOE', 'TOE(S), RIGHT FOOT'],
    ['MISS TONG', 'TONGUE'],
    ['MISS TONSL', 'TONSILS'],
    ['MISS UTRUS', 'UTERUS'],
    ['MISS C VRT', 'VERTEBRAE, CERVICAL'],
    ['MISS L VRT', 'VERTEBRAE, LUMBAR'],
    ['MISS VRT', 'VERTEBRAE, NONSPECIFIC']
];
exports.OPTIONS_SMT_THERAPY = [
    ['TD ANALGES', 'ANALGESICS (PAIN RELIEVERS -INCLUDES: DARVON, ACETOMINOPHEN, ASPIRIN, ETC.)'],
    ['TD ANTINFL', 'ANTI-INFLAMMATORY MEDICATION'],
    ['TD ANTBTCS', 'ANTIBIOTICS'],
    ['TD ACONVUL', 'ANTICONVULSANTS (SEIZURE MEDICINES - INCLUDES: DILANTINMYSOLINE, PHENOBARBITAL, ETC.)'],
    [
        'TD ADEPRES',
        'ANTIDEPRESSANTS (MOOD-LIFTERS -(MOOD LIFTERS - INCLUDES: AMITRIPTYLENE, ELAVIL, NORPRAMINE, PROZAC,TRIAVIL, ZOLOFT, ETC.)'
    ],
    ['TD BRNCHDL', 'BRONCHIAL DILATORS(INCLUDES INHALERS)'],
    ['TD CARDIAC', 'CARDIAC (HEART MEDICATIONS -INCLUDES: DIGITALIS, DIGOXIN, ETC.)'],
    ['TD HYPNOTI', 'HYPNOTICS (SLEEPING AIDES -INCLUDES: BARBITURATES, CHLORAL HYDRATE, GLUTETHEMIDE, ETC.)'],
    ['TD INSULIN', 'INSULIN'],
    ['TD OTHER', 'OTHER THERAPEUTIC MEDICATIONS NOT LISTED ABOVE, IDENTIFY IN THE MIS FIELD.'],
    ['TD RITALIN', 'RITALIN'],
    ['TD TRANQUI', 'TRANQUILIZERS (INCLUDES: VALIUM, THORAZINE, STELLAZINE,ETC.)']
];
exports.OPTIONS_SMT_HFRAC = [
    ['HFR L ANKL', 'ANKLE, LEFT'],
    ['HFR ANKL', 'ANKLE, NONSPECIFIC'],
    ['HFR R ANKL', 'ANKLE, RIGHT'],
    ['HFR L ARM', 'ARM, LEFT'],
    ['HFR LL ARM', 'ARM, LEFT, LOWER'],
    ['HFR UL ARM', 'ARM, LEFT, UPPER'],
    ['HFR ARM', 'ARM, NONSPECIFIC'],
    ['HFR R ARM', 'ARM, RIGHT'],
    ['HFR LR ARM', 'ARM, RIGHT, LOWER'],
    ['HFR UR ARM', 'ARM, RIGHT, UPPER'],
    ['HFR BACK', 'BACK'],
    ['HFR LCLAVI', 'CLAVICLE, LEFT'],
    ['HFR CLAVIC', 'CLAVICLE, NONSPECIFIC'],
    ['HFR RCLAVI', 'CLAVICLE, RIGHT'],
    ['HFR L ELB', 'ELBOW, LEFT'],
    ['HFR ELBOW', 'ELBOW, NONSPECIFIC'],
    ['HFR R ELB', 'ELBOW, RIGHT'],
    ['HFR L FGR', 'FINGER(S), LEFT HAND'],
    ['HFR FGR', 'FINGER(S), NONSPECIFIC'],
    ['HFR R FGR', 'FINGER(S), RIGHT HAND'],
    ['HFR L FOOT', 'FOOT, LEFT'],
    ['HFR FOOT', 'FOOT, NONSPECIFIC'],
    ['HFR R FOOT', 'FOOT, RIGHT'],
    ['HFR L HAND', 'HAND, LEFT'],
    ['HFR HAND', 'HAND, NONSPECIFIC'],
    ['HFR R HAND', 'HAND, RIGHT'],
    ['HFR L HIP', 'HIP, LEFT'],
    ['HFR HIP', 'HIP, NONSPECIFIC'],
    ['HFR R HIP', 'HIP, RIGHT'],
    ['HFR LL JAW', 'JAW, LEFT, LOWER'],
    ['HFR UL JAW', 'JAW, LEFT, UPPER'],
    ['HFR JAW', 'JAW, NONSPECIFIC'],
    ['HFR LR JAW', 'JAW, RIGHT, LOWER'],
    ['HFR UR JAW', 'JAW, RIGHT, UPPER'],
    ['HFR L KNEE', 'KNEE, LEFT'],
    ['HFR KNEE', 'KNEE, NONSPECIFIC'],
    ['HFR R KNEE', 'KNEE, RIGHT'],
    ['HFR L LEG', 'LEG, LEFT'],
    ['HFR LL LEG', 'LEG, LEFT, LOWER'],
    ['HFR UL LEG', 'LEG, LEFT, UPPER'],
    ['HFR LEG', 'LEG, NONSPECIFIC'],
    ['HFR R LEG', 'LEG, RIGHT'],
    ['HFR LR LEG', 'LEG, RIGHT, LOWER'],
    ['HFR UR LEG', 'LEG, RIGHT, UPPER'],
    ['HFR NECK', 'NECK'],
    ['HFR NOSE', 'NOSE'],
    ['HFR LPELVI', 'PELVIS BONE, LEFT'],
    ['HFR RPELVI', 'PELVIS BONE, RIGHT'],
    ['HFR PELVIS', 'PELVIS, NONSPECIFIC'],
    ['HFR L RIB', 'RIB(S), LEFT'],
    ['HFR RIBS', 'RIB(S), NONSPECIFIC'],
    ['HFR R RIB', 'RIB(S), RIGHT'],
    ['HFR L SHLD', 'SHOULDER, LEFT'],
    ['HFR SHLD', 'SHOULDER, NONSPECIFIC'],
    ['HFR R SHLD', 'SHOULDER, RIGHT'],
    ['HFR SKULL', 'SKULL'],
    ['HFR SPINE', 'SPINE'],
    ['HFR STERN', 'STERNUM'],
    ['HFR L TOE', 'TOE(S), LEFT FOOT'],
    ['HFR TOE', 'TOE(S), NONSPECIFIC'],
    ['HFR R TOE', 'TOE(S), RIGHT FOOT'],
    ['HFR L WRST', 'WRIST, LEFT'],
    ['HFR WRIST', 'WRIST, NONSPECIFIC'],
    ['HFR R WRST', 'WRIST, RIGHT']
];
exports.OPTIONS_SMT_RTAT = [
    ['RTAT ABDM', 'ABDOMEN'],
    ['RTAT LANKL', 'ANKLE, LEFT'],
    ['RTAT ANKL', 'ANKLE, NONSPECIFIC'],
    ['RTAT RANKL', 'ANKLE, RIGHT'],
    ['RTAT L ARM', 'ARM, LEFT'],
    ['RTAT LFARM', 'ARM, LEFT, LOWER'],
    ['RTAT ULARM', 'ARM, LEFT, UPPER'],
    ['RTAT ARM', 'ARM, NONSPECIFIC'],
    ['RTAT FARM', 'ARM, NONSPECIFIC, LOWER'],
    ['RTAT R ARM', 'ARM, RIGHT'],
    ['RTAT RFARM', 'ARM, RIGHT, LOWER'],
    ['RTAT URARM', 'ARM, RIGHT, UPPER'],
    ['RTAT BACK', 'BACK'],
    ['RTAT LBRST', 'BREAST, LEFT'],
    ['RTAT BRST', 'BREAST, NONSPECIFIC'],
    ['RTAT RBRST', 'BREAST, RIGHT'],
    ['RTAT RBUTK', 'BUTTOCK, RIGHT'],
    ['RTAT LBUTK', 'BUTTOCKS, LEFT'],
    ['RTAT BUTTK', 'BUTTOCKS, NONSPECIFIC'],
    ['RTAT LCALF', 'CALF, LEFT'],
    ['RTAT CALF', 'CALF, NONSPECIFIC'],
    ['RTAT RCALF', 'CALF, RIGHT'],
    ['RTAT L CHK', 'CHEEK, LEFT'],
    ['RTAT CHEEK', 'CHEEK, NONSPECIFIC'],
    ['RTAT R CHK', 'CHEEK, RIGHT'],
    ['RTAT CHEST', 'CHEST'],
    ['RTAT CHIN', 'CHIN'],
    ['RTAT L EAR', 'EAR, LEFT'],
    ['RTAT EAR', 'EAR, NONSPECIFIC'],
    ['RTAT R EAR', 'EAR, RIGHT'],
    ['RTAT L ELB', 'ELBOW, LEFT'],
    ['RTAT ELBOW', 'ELBOW, NONSPECIFIC'],
    ['RTAT R ELB', 'ELBOW, RIGHT'],
    ['RTAT L EYE', 'EYE, LEFT'],
    ['RTAT EYE', 'EYE, NONSPECIFIC'],
    ['RTAT R EYE', 'EYE, RIGHT'],
    ['RTAT FACE', 'FACE, NONSPECIFIC'],
    ['RTAT L FGR', 'FINGER(S), LEFT HAND'],
    ['RTAT R FGR', 'FINGER(S), RIGHT HAND'],
    ['RTAT FNGR', 'FINGER, NONSPECIFIC'],
    ['RTAT LFOOT', 'FOOT, LEFT'],
    ['RTAT FOOT', 'FOOT, NONSPECIFIC'],
    ['RTAT RFOOT', 'FOOT, RIGHT'],
    ['RTAT FHD', 'FOREHEAD'],
    ['RTAT FLBOD', 'FULL BODY'],
    ['RTAT GROIN', 'GROIN AREA'],
    ['RTAT L HND', 'HAND, LEFT'],
    ['RTAT HAND', 'HAND, NONSPECIFIC'],
    ['RTAT R HND', 'HAND, RIGHT'],
    ['RTAT HEAD', 'HEAD, NONSPECIFIC'],
    ['RTAT L HIP', 'HIP, LEFT'],
    ['RTAT HIP', 'HIP, NONSPECIFIC'],
    ['RTAT R HIP', 'HIP, RIGHT'],
    ['RTAT LKNEE', 'KNEE, LEFT'],
    ['RTAT KNEE', 'KNEE, NONSPECIFIC'],
    ['RTAT RKNEE', 'KNEE, RIGHT'],
    ['RTAT L LEG', 'LEG, LEFT'],
    ['RTAT LEG', 'LEG, NONSPECIFIC'],
    ['RTAT R LEG', 'LEG, RIGHT'],
    ['RTAT LWLIP', 'LIP, LOWER'],
    ['RTAT LIP', 'LIP, NONSPECIFIC'],
    ['RTAT UPLIP', 'LIP, UPPER'],
    ['RTAT NECK', 'NECK'],
    ['RTAT NOSE', 'NOSE'],
    ['RTAT PENIS', 'PENIS'],
    ['RTAT LSHLD', 'SHOULDER, LEFT'],
    ['RTAT SHLD', 'SHOULDER, NONSPECIFIC'],
    ['RTAT RSHLD', 'SHOULDER, RIGHT'],
    ['RTAT LTHGH', 'THIGH, LEFT'],
    ['RTAT THGH', 'THIGH, NONSPECIFIC'],
    ['RTAT RTHGH', 'THIGH, RIGHT'],
    ['RTAT TOE', 'TOE(S), NONSPECIFIC'],
    ['RTAT L TOE', 'TOE, LEFT'],
    ['RTAT R TOE', 'TOE, RIGHT'],
    ['RTAT LWRS', 'WRIST, LEFT'],
    ['RTAT WRS', 'WRIST, NONSPECIFIC'],
    ['RTAT RWRS', 'WRIST, RIGHT']
];
exports.OPTIONS_SMT_UTAT = [
    ['UTAT ABDM', 'ABDOMEN'],
    ['UTAT LANKL', 'ANKLE, LEFT'],
    ['UTAT ANKL', 'ANKLE, NONSPECIFIC'],
    ['UTAT RANKL', 'ANKLE, RIGHT'],
    ['UTAT L ARM', 'ARM, LEFT'],
    ['UTAT LFARM', 'ARM, LEFT, LOWER'],
    ['UTAT ULAR', 'ARM, LEFT, UPPER'],
    ['UTAT ARM', 'ARM, NONSPECIFIC'],
    ['UTAT FARM', 'ARM, NONSPECIFIC, LOWER'],
    ['UTAT R ARM', 'ARM, RIGHT'],
    ['UTAT RFARM', 'ARM, RIGHT, LOWER'],
    ['UTAT URARM', 'ARM, RIGHT, UPPER'],
    ['UTAT BACK', 'BACK'],
    ['UTAT LBRST', 'BREAST, LEFT'],
    ['UTAT BRST', 'BREAST, NONSPECIFIC'],
    ['UTAT RBRST', 'BREAST, RIGHT'],
    ['UTAT LBUTK', 'BUTTOCK, LEFT'],
    ['UTAT RBUTK', 'BUTTOCK, RIGHT'],
    ['UTAT BUTTK', 'BUTTOCKS, NONSPECIFIC'],
    ['UTAT LCALF', 'CALF, LEFT'],
    ['UTAT CALF', 'CALF, NONSPECIFIC'],
    ['UTAT RCALF', 'CALF, RIGHT'],
    ['UTAT L CHK', 'CHEEK, LEFT'],
    ['UTAT CHEEK', 'CHEEK, NONSPECIFIC'],
    ['UTAT R CHK', 'CHEEK, RIGHT'],
    ['UTAT CHEST', 'CHEST'],
    ['UTAT CHIN', 'CHIN'],
    ['UTAT L EAR', 'EAR, LEFT'],
    ['UTAT EAR', 'EAR, NONSPECIFIC'],
    ['UTAT R EAR', 'EAR, RIGHT'],
    ['UTAT L ELB', 'ELBOW, LEFT'],
    ['UTAT ELBOW', 'ELBOW, NONSPECIFIC'],
    ['UTAT R ELB', 'ELBOW, RIGHT'],
    ['UTAT FACE', 'FACE, NONSPECIFIC'],
    ['UTAT L FGR', 'FINGER(S), LEFT HAND'],
    ['UTAT R FGR', 'FINGER(S), RIGHT HAND'],
    ['UTAT FNGR', 'FINGER, NONSPECIFIC'],
    ['UTAT LFOOT', 'FOOT, LEFT'],
    ['UTAT FOOT', 'FOOT, NONSPECIFIC'],
    ['UTAT RFOOT', 'FOOT, RIGHT'],
    ['UTAT FHD', 'FOREHEAD'],
    ['UTAT FLBOD', 'FULL BODY'],
    ['UTAT GROIN', 'GROIN AREA'],
    ['UTAT L HND', 'HAND, LEFT'],
    ['UTAT HAND', 'HAND, NONSPECIFIC'],
    ['UTAT R HND', 'HAND, RIGHT'],
    ['UTAT HEAD', 'HEAD, NONSPECIFIC'],
    ['UTAT L HIP', 'HIP, LEFT'],
    ['UTAT HIP', 'HIP, NONSPECIFIC'],
    ['UTAT R HIP', 'HIP, RIGHT'],
    ['UTAT LKNEE', 'KNEE, LEFT'],
    ['UTAT KNEE', 'KNEE, NONSPECIFIC'],
    ['UTAT RKNEE', 'KNEE, RIGHT'],
    ['UTAT L LEG', 'LEG, LEFT'],
    ['UTAT LEG', 'LEG, NONSPECIFIC'],
    ['UTAT R LEG', 'LEG, RIGHT'],
    ['UTAT LWLIP', 'LIP, LOWER'],
    ['UTAT LIP', 'LIP, NONSPECIFIC'],
    ['UTAT UPLIP', 'LIP, UPPER'],
    ['UTAT NECK', 'NECK'],
    ['UTAT NOSE', 'NOSE'],
    ['UTAT PENIS', 'PENIS'],
    ['UTAT LSHLD', 'SHOULDER, LEFT'],
    ['UTAT SHLD', 'SHOULDER, NONSPECIFIC'],
    ['UTAT RSHLD', 'SHOULDER, RIGHT'],
    ['UTAT LTHGH', 'THIGH, LEFT'],
    ['UTAT THGH', 'THIGH, NONSPECIFIC'],
    ['UTAT RTHGH', 'THIGH, RIGHT'],
    ['UTAT LWRS', 'WRIST, LEFT'],
    ['UTAT WRS', 'WRIST, NONSPECIFIC'],
    ['UTAT RWRS', 'WRIST, RIGHT']
];
//# sourceMappingURL=smt-options.js.map